import { ReactNode } from "react"
import useResizeObserver from "use-resize-observer"

// https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/

export type AnimateHeightProps = {
  expanded: boolean
  collapsedHeight?: string | number
  children: ReactNode
}

export const AnimateHeight = ({ expanded, collapsedHeight = 0, children }: AnimateHeightProps) => {
  const observer = useResizeObserver()

  const optimalHeight = observer.height || 0
  const height = expanded ? optimalHeight : collapsedHeight

  return (
    <div className="overflow-hidden transition-[height] duration-200" style={{ height }}>
      <div ref={observer.ref}>{children}</div>
    </div>
  )
}
